module.exports = __webpack_public_path__ + "img/rattanr.4f8d5f04.jpg";